// extracted by mini-css-extract-plugin
module.exports = {"textAndBadge":"PromotionalBannerItem_textAndBadge__C4Bev","textAndBadgeSingle":"PromotionalBannerItem_textAndBadgeSingle__Ubh37","badge":"PromotionalBannerItem_badge__3M1q_"};